import React from "react";
import "./Career.scss";
import careerNotice from "../../assets/career/ceo-ad.png";

const Career = () => {
  return (
    <>
      <div className="container">
        <div className="career">
          <div className="heading_box">Career</div>
          <div className="career_content">
            <img src={careerNotice} className="img-fluid" alt="" />
            <div>
              {/* <p>Source</p> */}
              <p className="mt-2">
                <i>Page 03, 10 July, 2025 </i>
              </p>
              <p>
                <i>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://epaper.thefinancialexpress.com.bd/#"
                  >
                    https://epaper.thefinancialexpress.com.bd/#
                  </a>
                </i>
              </p>
            </div>
            <div>
              {/* <p>Source 2</p> */}
              <p className="mt-2">
                <i>Page 07, 10 July, 2025 </i>
              </p>
              <p>
                <i>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://epaper.samakal.com/nogor-edition/2025-07-10/7"
                  >
                    https://epaper.samakal.com/nogor-edition/2025-07-10/7
                  </a>
                </i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Career;
